<template>
  <div class="arttextstyle-box">
    <router-link
      v-for="(item, key) in arttextstyles"
      :key="`${key}-item`"
      :to="{ path: `/media/arttextstyle/${item.slug}` }"
      v-slot="{ navigate }"
      custom
    >
      <div class="arttextstyle-box_card" @click="navigate">
        <div
          class="image"
          :style="{
            backgroundImage: `url(${item.search_image}`,
          }"
          @click="$router.push({ path: `/media/arttextstyle/${item.slug}` })"
        >
          <div class="image__preview"><p>Click to View</p></div>
        </div>
        <span class="tag">arttextstyle</span>
        <h3 class="title" @click="$router.push({ path: `/arttextstyle/${item.slug}` })">
          {{ item.title }}
        </h3>
        <span class="data">{{ item.date_published }} </span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    arttextstyles: Array,
  },
};
</script>

<style lang="scss" scoped>
.arttextstyle-box {
  @include gridLayoutFrColumns;

  &_card {
    @include flexColumnClickable;

    .image {
      position: relative;
      @include imageContainer();

      @media screen and (max-width: $md) {
        height: 40vw;
      }
      @media screen and (max-width: $xs) {
        height: 90vw;
      }

      &__preview {
        @include imagePreview;

        p {
          @include imagePreviewParagraph;
        }
      }
      &:hover {
        .image__preview {
          @include imageHoverEffect;
        }
      }
    }
    .tag {
      @include searchTag;
      margin-top: 0px;
    }
    .title {
      font-size: 3.125rem;
      line-height: 1.3;
      margin-bottom: 11px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      @media screen and (max-width: $xxl) {
        font-size: 24px;
      }
      @media screen and (max-width: $xs) {
        font-size: 22px;
      }
    }
    .data {
      font-size: 14px;
      line-height: 1.8;
      text-transform: uppercase;
    }
  }
}
</style>

